import React from "react";
import { Box, Typography, styled, Container, Grid } from "@mui/material";
import Layout from "../home/components/Layout";

import aboutImage1 from '../../assets/about-1.png';
import aboutImage2 from '../../assets/about-2.png';
import Message from "../components/message";
import { MessageSections } from "../components/message/message";

// Styled components
const PageWrapper = styled(Box)(({ theme }) => ({
    padding: theme.spacing(4, 0),
}));

const Header = styled(Typography)(({ theme }) => ({
    fontWeight: 700,
    fontSize: "2rem",
    textAlign: "center",
    marginBottom: theme.spacing(2),
}));

const SubHeader = styled(Typography)(({ theme }) => ({
    fontSize: "1rem",
    textAlign: "center",
    color: "#555",
    marginBottom: theme.spacing(4),
}));

const TextContent = styled(Typography)(({ theme }) => ({
    fontSize: "1rem",
    lineHeight: 1.6,
    color: "#333",
    marginBottom: theme.spacing(2),
}));

const ImageContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(2),
}));

const StyledImage = styled("img")({
    maxWidth: "100%",
    borderRadius: 4,
    boxShadow: "0px 2px 6px rgba(0,0,0,0.2)",
});

const About: React.FC = () => {
    return (
        <Layout>
            <PageWrapper>
                <Container maxWidth="lg">
                    <Header>
                        <Message
                            messageKey={"about_title"}
                            sectionId={MessageSections.MAIN}
                        />
                    </Header>
                    <SubHeader>
                        <Message
                            messageKey={"about_sub_title"}
                            sectionId={MessageSections.MAIN}
                        />
                    </SubHeader>
                    <Grid container spacing={4}>
                        <Grid item xs={12} md={6}>
                            <TextContent>
                                <strong>
                                    <Message
                                        messageKey={"about_text_top"}
                                        sectionId={MessageSections.MAIN}
                                    />
                                </strong>
                            </TextContent>
                            <TextContent>
                                <Message
                                    messageKey={"about_text_main"}
                                    sectionId={MessageSections.MAIN}
                                />
                            </TextContent>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <ImageContainer>
                                <StyledImage
                                    src={aboutImage1}
                                    alt="Barekam Logistics Vans"
                                />
                            </ImageContainer>
                            <ImageContainer>
                                <StyledImage
                                    src={aboutImage2}
                                    alt="Barekam Logistics Team"
                                />
                            </ImageContainer>
                        </Grid>
                    </Grid>
                </Container>
            </PageWrapper>
        </Layout>
    );
};

export default About;
